<ng-container [ngSwitch]="type">

  <input
    *ngSwitchCase="FilterType.STRING"
    class="th-filter-input"
    type="text"
    [placeholder]="placeholder"
    [value]="internalValue"
    (input)="onStringInput($any($event.target).value)"
  />

  <mat-form-field *ngSwitchCase="FilterType.DATE" class="th-date-range-field" appearance="outline">
    <input
      matInput
      [matDatepicker]="datePicker"
      [formControl]="dateControl"
      placeholder="Selecionar data"
      readonly
    >
    <mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>
    <mat-datepicker #datePicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field *ngSwitchCase="FilterType.DATE_RANGE" class="th-date-range-field" appearance="outline">
    <mat-date-range-input [formGroup]="dateRangeForm" [rangePicker]="picker" [separator]="'até'">
      <input matStartDate formControlName="start" placeholder="Início" readonly>
      <input matEndDate formControlName="end" placeholder="Fim" readonly>
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>

  <mat-select
    *ngSwitchCase="FilterType.SELECT"
    class="th-filter-select"
    [placeholder]="placeholder || 'Todos'"
    [ngModel]="internalValue"
    [compareWith]="compareValues"
    (ngModelChange)="onSelectChange($event)"
  >
    <mat-option [value]="null">Todos</mat-option>
    <mat-option *ngFor="let opt of options" [value]="opt.value">
      {{ opt.label }}
    </mat-option>
  </mat-select>

  <mat-select
    *ngSwitchCase="FilterType.SELECT_ASYNC"
    class="th-filter-select"
    [placeholder]="placeholder || 'Todos'"
    [ngModel]="internalValue"
    [compareWith]="compareValues"
    (ngModelChange)="onSelectChange($event)"
  >
    <mat-option [value]="null">Todos</mat-option>
    <mat-option *ngFor="let opt of asyncOptions" [value]="opt.value">
      {{ opt.label }}
    </mat-option>
  </mat-select>

</ng-container>
